const viewUpdates = {
	Failed : 'Failed',
	PartialSaved: 'PartialSaved',
	Refined: 'Refined'
};

export default viewUpdates;